import { switchMap, filter, startWith } from 'rxjs/operators'
import { interval, first, distinctUntilChanged, takeUntil, EMPTY } from 'rxjs'
import { Epic, ofType, StateObservable } from 'redux-observable'
import DashboardActionTypes from '../../actions/dashboard/DashboardActionTypes'
import { AudioFiles, audioService } from '../../../audio'
import { IStoreState } from '../../IStoreState'
import { RequestVehicleSuccess } from '../../actions/dashboard/DashboardAction'
import { ColumnNumber } from '../../../../entities/column/Column'

const ONE_SECOND = 1000
const FIVE_MINUTES = 5 * 60 * 1000
const FIRST_REMIND_TIME_IN_SEC = 30 * 60
const ALERT_TIME_IN_SEC = 5 * 60

const vehicleIdSelector = (action: RequestVehicleSuccess) =>
    action.payload.vehicles[0].id

const vehicleIdComparator = (prev: string, next: string) => prev === next

const hasUpcomingCycleOrders = (state$: StateObservable<IStoreState>) =>
    !!state$.value.Dashboard.columns[ColumnNumber.READY]?.upcomingCycle
        ?.numberOfOpenOrders

/**
 * Notice when vehicle appears epic
 */
export const vehicleNoticeEpic: Epic = (
    action$,
    state$: StateObservable<IStoreState>
) =>
    action$.pipe(
        ofType(DashboardActionTypes.REQUEST_VEHICLE_SUCCESS),
        filter(() => state$.value.Dashboard.vehicles.length > 0),
        distinctUntilChanged(vehicleIdComparator, vehicleIdSelector),
        switchMap(() =>
            interval(ONE_SECOND).pipe(
                startWith(0),
                filter(() => {
                    return (
                        state$.value.Dashboard.vehicles[0]?.progress() > 0 &&
                        state$.value.Dashboard.vehicles[0]?.arrivesIn <=
                            state$.value.Dashboard.vehicles[0]
                                ?.arrivalDuration &&
                        state$.value.Dashboard.vehicles[0]?.arrivesIn >
                            FIRST_REMIND_TIME_IN_SEC
                    )
                }),
                first(),
                switchMap(() => {
                    audioService.play(AudioFiles.NOTIFY_SOUND)
                    return EMPTY
                })
            )
        )
    )

/**
 * Vehicle reminder epic
 */
export const vehicleReminderEpic: Epic = (
    action$,
    state$: StateObservable<IStoreState>
) =>
    action$.pipe(
        ofType(DashboardActionTypes.REQUEST_VEHICLE_SUCCESS),
        filter(() => state$.value.Dashboard.vehicles.length > 0),
        distinctUntilChanged(vehicleIdComparator, vehicleIdSelector),
        switchMap(() =>
            interval(ONE_SECOND).pipe(
                startWith(0),
                filter(
                    () =>
                        state$.value.Dashboard.vehicles[0]?.arrivesIn <=
                            FIRST_REMIND_TIME_IN_SEC &&
                        // чтобы не воспроизводилось если < 5 минут
                        state$.value.Dashboard.vehicles[0]?.arrivesIn >
                            ALERT_TIME_IN_SEC
                ),
                first(),
                switchMap(() => {
                    const interval$ = interval(FIVE_MINUTES)
                    return interval$.pipe(
                        startWith(0),
                        takeUntil(
                            interval$.pipe(
                                filter(
                                    () =>
                                        state$.value.Dashboard.vehicles[0]
                                            ?.arrivesIn <=
                                        ALERT_TIME_IN_SEC + 1
                                )
                            )
                        ),
                        filter(
                            () => state$.value.Dashboard.vehicles.length > 0
                        ),

                        switchMap(() => {
                            audioService.play(AudioFiles.REMINDER_SOUND)
                            return EMPTY
                        })
                    )
                })
            )
        )
    )

/**
 * Final vehicle reminder epic
 */
export const vehicleFinalReminderEpic: Epic = (
    action$,
    state$: StateObservable<IStoreState>
) =>
    action$.pipe(
        ofType(DashboardActionTypes.REQUEST_VEHICLE_SUCCESS),
        filter(() => state$.value.Dashboard.vehicles.length > 0),
        distinctUntilChanged(vehicleIdComparator, vehicleIdSelector),
        switchMap(() =>
            interval(ONE_SECOND).pipe(
                startWith(0),
                // filter(() => hasUpcomingCycleOrders(state$)),
                filter(
                    () => state$.value.Dashboard.vehicles[0]?.progress() > 0
                ),
                filter(
                    () =>
                        state$.value.Dashboard.vehicles[0]?.arrivesIn <=
                        ALERT_TIME_IN_SEC
                ),
                first(),
                switchMap(() => {
                    audioService.play(AudioFiles.ALERT_SOUND)
                    return EMPTY
                })
            )
        )
    )

export const soundEpics = [
    vehicleNoticeEpic,
    vehicleReminderEpic,
    vehicleFinalReminderEpic,
]
